<template>
  <div class="card-form">
    <EditForm
      ref="editForm"
      :disabled="disabled"
      :amzReplenishmentCode="amzReplenishmentCode"
    />
  </div>
</template>
<script>
import EditForm from '../components/edit-form'
export default {
  name: 'ecom-awsBiz-replenishmentConfirm-detail',
  components: { EditForm },
  computed: {
    params() {
      return this.$route.params
    },
    amzReplenishmentCode() {
      return this.params.code
    },
    pageType() {
      return this.params.pageType
    },
    disabled() {
      return this.pageType === 'detail'
    },
  },
}
</script>
